if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"host","remotes":[{"alias":"lk","name":"lk","entry":"https://lk-mf.stage.d2c.r-one.io/_next/static/chunks/remoteEntry.js","shareScope":"default"}]},
		chunkMatcher: function(chunkId) {return true},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}